export type AppMode = 'pwa' | 'max';

/**
 * Режим запуска по origin. MAX опознаём положительно — по записи в botMap:
 * тот же признак, по которому определяются регион и бот. Незнакомый origin
 * (localhost, превью-стенд) считается браузерной PWA, иначе разработка
 * молча уходила бы в ветку мини-приложения.
 */
export function getAppMode(): AppMode {
  const config = window.__CONFIG__;
  const origin = window.location.origin;

  if (origin === config?.pwaOrigin) return 'pwa';

  return config?.botMap?.some((item) => item.origin === origin)
    ? 'max'
    : 'pwa';
}
